export const removeFields = <T>(object: T, fields: (keyof T)[]) => {
  const newObject = {
    ...object,
  };
  fields.forEach((field) => {
    delete newObject[field];
  });
  return newObject;
};
